import React, { Component, type ComponentType } from 'react';
import flow from 'lodash/flow';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import { withFlagService, type FlagService } from '@atlassian/jira-flags';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { MODAL } from '@atlassian/jira-product-analytics-bridge';
import type { RefObject } from '@atlassian/jira-shared-types/src/general.tsx';
import setPagesLinkErrorFlag from '../../../flags/set-pages-link-error/index.tsx';
import Content, { type Props as ContentProps } from './content/index.tsx';
import PagesSelector from './content/pages-selector/index.tsx';
import View from './view.tsx';

export type Props = Flow.Diff<
	ContentProps,
	{
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		PagesSelector: ComponentType<Record<any, any>>;
	}
> & {
	pages: {
		isEnabled: boolean;
		setPagesLink: (enable: boolean) => Promise<void>;
	};
	onClose: () => void;
	onCloseComplete?: () => void;
	addItemButtonRef?: RefObject;
};

const InjectedView = injectIntl(View);

// eslint-disable-next-line jira/react/no-class-components
class SelectItemTypeModal extends Component<
	Props & {
		flagService: FlagService;
	}
> {
	onEnabledChange = () => {
		const { pages } = this.props;
		pages.setPagesLink(!pages.isEnabled).catch(() => {
			this.props.flagService.showFlag(setPagesLinkErrorFlag());
		});
	};

	renderPagesSelector = () => (
		<PagesSelector isEnabled={this.props.pages.isEnabled} onEnabledChange={this.onEnabledChange} />
	);

	renderContent = () => (
		<Content
			PagesSelector={this.renderPagesSelector}
			onAddLink={this.props.onAddLink}
			onAddRepo={this.props.onAddRepo}
			showPagesSelector={this.props.showPagesSelector}
		/>
	);

	render() {
		return (
			<InjectedView
				addItemButtonRef={this.props.addItemButtonRef}
				onClose={this.props.onClose}
				Content={this.renderContent}
				onCloseComplete={this.props.onCloseComplete}
			/>
		);
	}
}

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export default flow(
	AnalyticsSource('addNavigationItems', MODAL),
	withFireUiAnalytics({
		onClose: 'close',
	}),
	withFlagService,
)(SelectItemTypeModal) as ComponentType<Props>;
